export const userAddNoteComponent = {
  template: `<user-note-main
      title="Add Note">
  </user-note-main>`,
};



// WEBPACK FOOTER //
// ./src/app/components/user/user-add-note/user-add-note.component.js